import Link from 'next/link'
import { Icon } from './icon'

export interface Crumb {
  label: string
  href?: string
}

/** Trilha de navegação (SEO + UX). O último item é o atual (sem link). */
export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Trilha" className="mb-4 flex flex-wrap items-center gap-1.5 text-[12.5px] text-ink-faint">
      {items.map((item, i) => {
        const last = i === items.length - 1
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            {item.href && !last ? (
              <Link href={item.href} className="hover:text-brand">
                {item.label}
              </Link>
            ) : (
              <span className={last ? 'text-ink-mute' : undefined}>{item.label}</span>
            )}
            {!last && <Icon name="chevron" size={13} />}
          </span>
        )
      })}
    </nav>
  )
}
